import { render } from "./dimensionOptionAwnings.vue?vue&type=template&id=3d14eb08"
import script from "./dimensionOptionAwnings.vue?vue&type=script&lang=js"
export * from "./dimensionOptionAwnings.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/loewe-zaun-live-56lid4vr.on-forge.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__